import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginAdmin } from '../../services/adminAuth';
import { Lock } from 'lucide-react';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await loginAdmin(email, password);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Erreur de connexion au serveur.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center p-4">
      <div className="bg-black/50 p-8 rounded-lg border border-[#D4AF37]/30 shadow-2xl shadow-[#D4AF37]/10 w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <div className="bg-[#D4AF37]/10 p-4 rounded-full mb-4">
            <Lock className="w-8 h-8 text-[#D4AF37]" />
          </div>
          <h1 className="text-2xl font-bold text-white tracking-widest uppercase">Janus Capital</h1>
          <p className="text-[#D4AF37] text-sm mt-2">Portail d'Accès</p>
        </div>

        {error && (
          <div className="bg-red-500/10 border border-red-500 text-red-500 p-3 rounded mb-6 text-sm text-center">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-gray-400 text-sm mb-2">Identifiant / Email</label>
            <input 
              type="email" autoComplete="username" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#1A1A1A] border border-gray-800 text-white px-4 py-3 rounded focus:outline-none focus:border-[#D4AF37] transition-colors"
              placeholder="admin@janus.com"
              required
            />
          </div>

          <div>
            <label className="block text-gray-400 text-sm mb-2">Mot de passe</label>
            <input 
              type="password" autoComplete="current-password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#1A1A1A] border border-gray-800 text-white px-4 py-3 rounded focus:outline-none focus:border-[#D4AF37] transition-colors"
              placeholder="••••••••"
              required
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-[#D4AF37] hover:bg-[#b5952f] text-black font-bold py-3 px-4 rounded transition-colors mt-4 disabled:opacity-50"
          >
            {loading ? 'Authentification...' : 'Accéder au coffre'}
          </button>
        </form>
      </div>
    </div>
  );
}
